import { useEffect, useRef } from 'react';
export var DEFAULT_USE_CLICK_OUTSIDE_EVENTS = ['mousedown', 'touchstart'];
/**
 * A hook that enables a component to listen for outside click events and act on them
 *
 * @param onOutsideClick callback to fire when an outside click is detected
 * @param events events to listen for to trigger the callback
 * @param ignoreElement element to ignore outside clicks from
 * @param ignoreFloatingUIElements If `true`, the outside click handler won't be triggered
 * when the clicked element is inside a `<FloatingUI>` (and thus is assumed to be inside a React portal).
 *
 * @returns ref of the element
 */
export function useClickOutside(_a) {
    var onOutsideClick = _a.onOutsideClick, _b = _a.events, events = _b === void 0 ? DEFAULT_USE_CLICK_OUTSIDE_EVENTS : _b, ignoreElement = _a.ignoreElement, ignoreFloatingUIElements = _a.ignoreFloatingUIElements;
    var ref = useRef(null);
    useEffect(function () {
        var listener = function (ev) {
            var _a;
            // Do not trigger the outside click handler if the ref'd element
            // or the optional ignored element were clicked.
            if (ev.target instanceof Node &&
                (((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(ev.target)) || ((ignoreElement === null || ignoreElement === void 0 ? void 0 : ignoreElement.contains) && (ignoreElement === null || ignoreElement === void 0 ? void 0 : ignoreElement.contains(ev.target))))) {
                return;
            }
            if (ignoreFloatingUIElements && ev.target instanceof Element && ev.target.closest('.Hawkins-FloatingUI')) {
                return;
            }
            onOutsideClick(ev);
        };
        events.forEach(function (fn) { return document.addEventListener(fn, listener); });
        return function () {
            events.forEach(function (fn) { return document.removeEventListener(fn, listener); });
        };
    }, [ref, onOutsideClick, events, ignoreElement, ignoreFloatingUIElements]);
    return ref;
}
useClickOutside.displayName = 'useClickOutside';
